import store from '@/store';
import router from '@/router';
import { ErrorResponse } from './axios_types';
import { translate as $t } from '@/i18n';
import { $error } from '@/helpers';

let vueInstance: any = null;

export function initErrorHandler(vue: any) {
  vueInstance = vue;
}

function showError(message: string) {
  if (vueInstance && vueInstance.$error) {
    vueInstance.$error({
      centered: true,
      title: $t('common.e500'), 
      content: $t(message),
      // onOk: () => {
      //   store.commit('common/SERVER_ERROR', null);
      // }
    });
  } else {
    console.error('UI Error:', $t(message));
  }
}

export function handleUnauthorized() {
  localStorage.removeItem('authorization');
  store.commit('user/SET_USER_DATA', null);
  router.push('/login');
}

export function handleForbidden() {
  console.error('Error 403 - Access denied');
  store.commit('user/ERROR_LOGIN', $t('common.e403'));
}

export function handleNotFound(isApiRequest: boolean = false) {
  console.error('404 ERROR: Resource not found');
  if (isApiRequest) {
    // Для API запросов только показываем уведомление
    showError('common.api404');
  } else {
    // Для навигации редиректим на страницу 404
    router.replace({ name: 'NotFound' });
  }
}

export function handleGenericError(errorData: ErrorResponse, shouldShow: boolean = true) {
  const message = extractErrorMessage(errorData);
  
  console.error('API Error:', message);
  store.commit('common/SERVER_ERROR', message);
  
  if (shouldShow) {
    showError(message);
  }
  
  return message;
}

export function showNetworkError() {
  if (vueInstance && vueInstance.$error) {
    vueInstance.$error({title: $t('common.errors.network')});
  } else {
    console.error('Network Error: Server connection failed');
  }
}

export function extractErrorMessage(errorData: ErrorResponse): string {
  if (errorData.name && errorData.message) {
    return `${errorData.name}: ${errorData.message}`;
  }
  
  return errorData.message || 
         errorData.text || 
         errorData.error || 
         'Произошла неизвестная ошибка';
}